if($('.type-category .breadcrumbs').length){
    var newclass = $('#navigation-1 span[itemprop="name"]').text()
    var newclass = newclass.normalize('NFD').replace(/[^\w]/g, '').toLowerCase();
    $('body').addClass(newclass)
}